import {
  resolveOwnedDashboardContext,
  ShigoDashboardContext,
} from '../features/auth/dashboardDestination';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { DashboardScope } from '../features/dashboard/model';
import { useShigoSession } from '../lib/useShigoSession';

export function HomePage() {
  const { session } = useShigoSession();

  if (session && resolveOwnedDashboardContext(session.user) === ShigoDashboardContext.SuperAdmin) {
    return <DashboardPage scope={DashboardScope.SuperAdmin} />;
  }

  return <DashboardPage />;
}
